import React from 'react';

import ErrorBoundary from '@hrms/common/component/error-boundary';
import { Button, Modal } from '@zeptonow/zui';
import { ModalMaxWidth } from './types';
import { generateImage } from '@hrms/common/utils/generateImage';

interface ModalComponentProps {
  title?: React.ReactNode;
  description: React.ReactNode;
  actionButton: React.ReactNode;
  open: boolean;
  handleClose: () => void | undefined;
  hideCrossIcon?: boolean;
  maxWidth?: ModalMaxWidth;
  className?: string;
  descriptionClassName?: string;
  modalSx?: Record<string, any>; // For sx prop
}

const { Title, Actions } = Modal;

const ModalComponent: React.FC<ModalComponentProps> = ({
  title,
  description,
  actionButton,
  open,
  maxWidth = 'sm',
  handleClose,
  hideCrossIcon,
  className = '',
  descriptionClassName = '',
  modalSx = {},
}) => {
  return (
    <ErrorBoundary>
      <Modal
        fullWidth
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        className={className}
        sx={modalSx}
      >
        {(title || !hideCrossIcon) && (
          <Title>
            {title}
            {!hideCrossIcon && (
              <Button
                id="hide-save-config-modal"
                onClick={handleClose}
                variant="text"
                className="!absolute !top-3 !right-0"
              >
                {generateImage({
                  name: 'cross',
                  alt: 'cross icon',
                  className: 'h-4 w-4',
                })}
              </Button>
            )}
          </Title>
        )}
        {description ? (
          <div className={`p-6 ${descriptionClassName}`}>{description}</div>
        ) : null}
        {actionButton ? <Actions>{actionButton}</Actions> : null}
      </Modal>
    </ErrorBoundary>
  );
};

export default ModalComponent;
